export enum MetricConversionType {
  Number = 0,
  Seconds = 1,
  Minutes = 2,
  Hours = 3,
  Time = 4,
  Percentage = 5
}

export interface RangeSliderConfig {
  step: number;
  startPoints: number[];
  values: number[];
  disabled: boolean;
  connect: boolean | boolean[];
  colorClasses: string[];
  min?: number;
  max?: number;
  showMinMax?: boolean;
  showControls?: boolean;
  title?: string;
}

export interface RangeModel {
  enabled: boolean;
  left: number | string;
  right: number | string;
}

export enum RangeSliderColor {
  StronglyNegative = "#D6604D",
  Negative = "#FFAB84",
  Neutral = "#F8F8F9",
  ModeratelyPositive = "#B3D4E7",
  StronglyPositive = "#DCFE00FF",
}

export interface RangeSliderColorMap {
  [key: string]: string;
}

export const RANGE_SLIDER_ERRORS = {
  Invalid_Number: 'Enter a numerical value',
  Min_Less_Than_Zero: 'Min value cannot be less than 0',
  Max_Greater_Than_100: 'Max value cannot be greater than 100',
  Min_Greater_Than_100: 'Min value cannot be greater than 100',
  Max_Less_Than_Zero: 'Max value cannot be less than 0',
  Min_Less_Than_Neg_1000: 'Min value cannot be less than -1000',
  Max_Less_Than_Neg_1000: 'Max value cannot be less than -1000',
  Min_Max_Same: 'Min and Max values cannot be the same',
  Min_Not_Less_Than_Max: 'Min value must be less than the Max value',
  Max_Not_Greater_Than_Min: 'Max value must be greater than the Min value',
  Invalid_Time_Format: 'Enter time in HH:MM:SS format',
};

export const RANGE_SLIDER_COLORS: RangeSliderColorMap = {
  StronglyNegative: RangeSliderColor.StronglyNegative,
  Negative: RangeSliderColor.Negative,
  Neutral: RangeSliderColor.Neutral,
  ModeratelyPositive: RangeSliderColor.ModeratelyPositive,
  StronglyPositive: RangeSliderColor.StronglyPositive
};

export class RangeSliderModel implements RangeSliderConfig {
  step = 1;
  startPoints = [0, 100];
  values = [0, 100];
  disabled = false;
  connect: boolean | boolean[] = true;
  colorClasses: string[] = [];
  min = 0;
  max = 100;
  showMinMax = true;
  showControls = true;
  title?: string;

  constructor(config?: Partial<RangeSliderConfig>) {
    if (config) {
      Object.assign(this, config);
    }
  }

  updateMin(value: number): void {
    this.min = Math.max(0, Math.min(value, this.max - this.step));
    if (this.values[0] < this.min) {
      this.values = [this.min, ...this.values.slice(1)];
    }
  }

  updateMax(value: number): void {
    this.max = Math.max(this.min + this.step, value);
    if (this.values[this.values.length - 1] > this.max) {
      this.values = [...this.values.slice(0, -1), this.max];
    }
  }

  isValidRange(): boolean {
    return this.min < this.max && this.values.every(val => val >= this.min && val <= this.max);
  }
}